import { ASCENDING_KEY, SORT_BY_KEY } from '@/constants/state'
import { useSearchState } from '@/hooks/useSearchState'
import type { VaultsSortSchema } from '@/types/vaultsSortSchema'
import { type VaultsTableColumn, isVaultsTableColumn } from '@/types/vaultsTableColumn'

const DEFAULT_SORT_BY: VaultsTableColumn = 'tvl'
const DESCENDING_COLUMNS = ['tvl', 'apy', 'holders', 'score']

export function useVaultsSortState() {
  const { searchState, updateSearchState } = useSearchState({})

  const handleSetSortBy = (name: VaultsSortSchema['sortBy']): void => {
    const descendingByDefault = DESCENDING_COLUMNS.includes(name)
    const sortBy = searchState.get(SORT_BY_KEY)
    const previousAsc = searchState.get(ASCENDING_KEY) === 'true'
    const asc = sortBy === name ? !previousAsc : !descendingByDefault

    updateSearchState([SORT_BY_KEY, name], [ASCENDING_KEY, asc])
  }

  const asc = searchState.get(ASCENDING_KEY) === 'true'
  const sortByRaw = searchState.get(SORT_BY_KEY) ?? ''
  const sortBy = isVaultsTableColumn(sortByRaw) ? sortByRaw : DEFAULT_SORT_BY

  const sortState = {
    sortBy,
    asc,
  }

  return { handleSetSortBy, sortState }
}
